export const onlyNumbers = (e: KeyboardEvent) => !/\d/.test(e.key) && e.preventDefault();
